import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function isImageUrl(url = '') {
  return /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(url);
}

const FileAttachment = ({ attachments }) => {
  if (!attachments?.data) return null;
  const files = Array.isArray(attachments.data) ? attachments.data : [attachments.data];
  return (
    <Box display="flex" flexWrap="wrap" gap={2} mt={1}>
      {files.map((file, idx) => {
        if (!file?.attributes) return null;
        const { url, name, mime } = file.attributes;
        if (isImageUrl(url)) {
          return (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              key={file.id || idx}
              style={{ display: 'block' }}
            >
              <img
                src={url}
                alt={name}
                title={name}
                style={{
                  maxWidth: 120,
                  maxHeight: 120,
                  borderRadius: 8,
                  border: '1px solid #ddd',
                  marginBottom: 4,
                  display: 'block',
                }}
              />
              <Typography variant="caption" display="block" align="center">
                {name}
              </Typography>
            </a>
          );
        }
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            key={file.id || idx}
            style={{ minWidth: 80, display: 'block' }}
          >
            <Typography variant="body2" noWrap>
              {name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {mime}
            </Typography>
          </a>
        );
      })}
    </Box>
  );
};

export default FileAttachment;
